import { motion } from 'motion/react';

import styled from 'styled-components';
import Icon, { ICON_RIGHT } from '~/components/icon/index.js';

import Anchor from './anchor.js';
import SkeletonPlaceholder from '../utilities/pulsating-placeholder.js';
import useRetainDefaultParams from '~/hooks/use-retain-default-params';

const variants = {
	sidebarOpen: {
		y: 0,
		opacity: 1,
		transition: { y: { stiffness: 1000, velocity: -100 } }
	},
	sidebarClosed: { y: 50, opacity: 0 }
};

const LinkListBadge = styled.span`
	position: absolute;
	margin-top: -5px;
	margin-left: 4px;
`;
/**
 * @param {object} props
 * @param {string} [props.title]
 * @param {React.StatelessComponent} [props.TitleLogo]
 * @param {React.StatelessComponent} [props.PrimaryIcon]
 * @param {React.StatelessComponent} [props.StatusIcon]
 * @param {React.MouseEventHandler} [props.onClick]
 * @param {string | object} [props.to]
 * @param {string} [props.href]
 * @param {string} [props.subTitle]
 * @param {string} [props.className]
 * @param {any} [props.value]
 * @param {string } [props.dataAt]
 * @param {React.ReactChildren} [props.children]
 * @param {React.StatelessComponent} [props.badge]
 * @param {object} [props.state]
 * @param {object} [props.trackEvent]
 */

function LinkList({
	PrimaryIcon = () => null,
	title,
	TitleLogo = () => null,
	subTitle,
	badge,
	StatusIcon = () => <Icon type={ICON_RIGHT} className="link-list__continue-icon" />,
	className = '',
	valueClassName = '',
	value = null,
	dataAt = '',
	children,
	disabled,
	paymentTag,
	onPaymentProviders,
	provider,
	providerText,
	to: initialTo,
	state = {},
	trackEvent,
	...rest
}) {
	const iconClassName = !value ? 'link-list__continue-icon' : 'u-m0';
	const getLocationWithParams = useRetainDefaultParams();
	const to = getLocationWithParams(initialTo);

	return (
		<motion.li
			variants={variants}
			className={`link-list__item ${className} ${disabled ? 'disabled' : ''}`}
			data-at={dataAt}
		>
			<Anchor
				className={`link-list__item-link ${onPaymentProviders ? 'p-tb' : ''} `}
				data-at="list-item-link"
				to={to}
				state={state}
				trackEvent={trackEvent}
				{...rest}
			>
				{!!paymentTag && (
					<div
						className={
							paymentTag.primaryColor
								? 'payment-tag payment-tag__popular'
								: 'payment-tag payment-tag__no-fee'
						}
						data-at="popular-tag-icon"
					>
						{paymentTag.tagText}
					</div>
				)}

				<PrimaryIcon />
				<span className="u-text-l u-relative u-fs2">
					<span className="menu__main-title font-title">{title}</span>
					{providerText && (
						<small data-at="amount-input-feedback-text" className="payment__amount-info">
							{providerText}
						</small>
					)}
					{badge && <LinkListBadge>{badge}</LinkListBadge>}
					{subTitle && <span className="link-list__preamble u-db">{subTitle}</span>}
				</span>
				<TitleLogo />
				{value && <span className={`link-list__value ${valueClassName}`}>{value}</span>}
				{StatusIcon && <StatusIcon className={iconClassName} />}
			</Anchor>
			{children}
		</motion.li>
	);
}

const SkeletonLinkList = () => (
	<motion.li className="link-list__item" variants={variants}>
		<span className="link-list__item-link">
			<SkeletonPlaceholder />
			<span className="menu__main-title">
				<SkeletonPlaceholder />
			</span>
		</span>
	</motion.li>
);

export default LinkList;

export { SkeletonLinkList };
